import { TemplateTag } from '@/communications/templates/models/template-tag';
import { TemplateTagLink } from '@/communications/templates/models/message-template';

export interface TemplateTagOption {
    id: number;
    name: string;
}

interface TagWithSystemLocked extends TemplateTagOption {
    isSystemLocked: boolean;
}

export function extractTagName(tag: TemplateTag): string {
    return tag.values && tag.values.length > 0 ? tag.values[0].name : '';
}

export function isSystemLockedTag(tag: TemplateTag): boolean {
    const tagAny = tag as any;
    return tagAny.is_system_locked || false;
}

export function mapTagsToOptions(tags: Array<TemplateTag>): Array<TagWithSystemLocked> {
    return tags
        .map((tag: TemplateTag) => ({
            id: tag.id,
            name: extractTagName(tag),
            isSystemLocked: isSystemLockedTag(tag)
        }))
        .filter(tag => tag.name && tag.name.trim().length > 0);
}

export function sortTags(tags: Array<TagWithSystemLocked>): Array<TagWithSystemLocked> {
    return [...tags].sort((a, b) => {
        if (a.isSystemLocked === b.isSystemLocked) {
            return a.name.localeCompare(b.name);
        }
        return a.isSystemLocked ? -1 : 1;
    });
}

export function removeSystemLockedProperty(tags: Array<TagWithSystemLocked>): Array<TemplateTagOption> {
    return tags.map(({ id, name }) => ({ id, name }));
}

export function processTemplateTags(tags: Array<TemplateTag>): Array<TemplateTagOption> {
    const mappedTags = mapTagsToOptions(tags);
    const sortedTags = sortTags(mappedTags);
    return removeSystemLockedProperty(sortedTags);
}

export function formatTemplateTags(tags?: Array<TemplateTagLink>): string {
    if (!tags?.length) {
        return '';
    }

    return tags
        .map(tag => tag.values?.name?.trim() || '')
        .filter(Boolean)
        .join(', ');
}
